(function () {
/*
* -----------------------------------------------------------------------------
* @cam/quantity-input
* -----------------------------------------------------------------------------
* @version 0.0.6
* @overview Custom quantity input field with plus and minus buttons.
* @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
* -----------------------------------------------------------------------------
*/ if (customElements.get("quantity-input") === undefined) {
    class QuantityInput extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.input = this.querySelector("input");
            this.buttons = this.querySelectorAll("button");
            this.classList.add("javascript");
            this.buttons.forEach((button)=>{
                button.hidden = false;
                button.addEventListener("click", this.onButtonClick.bind(this));
            });
            this.input.addEventListener("change", this.dispatchNewEvent.bind(this));
        }
        disconnectedCallback() {
            this.classList.remove("javascript");
            this.buttons.forEach((button)=>{
                button.hidden = true;
                button.removeEventListener("click", this.onButtonClick.bind(this));
            });
        }
        onButtonClick(event) {
            event.preventDefault();
            let previousValue = this.input.value;
            if (event.target.name === "minus" && this.input.min === this.input.value) return;
            event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
            if (previousValue === this.input.value) return;
            this.input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        }
        dispatchNewEvent(event) {
            this.dispatchEvent(new CustomEvent("updated", {
                detail: {
                    value: event.target.valueAsNumber
                }
            }));
        }
    }
    customElements.define("quantity-input", QuantityInput);
}



})();
